import type { EventReminder } from 'models';
import { Modal } from 'ui';
import { SendInvitationsModalContent } from './send-invitations-modal-content';

type P = {
  event: EventReminder;
  isOpened: boolean;
  onClose: () => void;
};

const SendInvitationsModal = ({ event, isOpened, onClose }: P) => (
  <Modal
    isOpened={isOpened}
    maskProps={{
      closable: false,
    }}
    onCancel={() => {
      onClose();
    }}
    title="Add people"
    width="medium"
  >
    <Modal.HugContent>
      <SendInvitationsModalContent event={event} onClose={onClose} />
    </Modal.HugContent>
  </Modal>
);

export default SendInvitationsModal;
